// NAMING CONVENTION FOR KEYS
// useCaseDescription
// eg:
// - formLabelEmail: 'Email',
// - formValidationEmailRequired: 'please enter an email'
// - formSubmitButtonLogin: 'Login'
// - commonLabelPhoneNumber: '03456 049 049',
// - messageInternalServerErrorTitle: 'Sorry, we’ve had a technical problem',
// - messageInternalServerErrorBody: 'Please <a href="${url}" data-action="handback">return to the homepage</a> and try again',

const defaultStaticContent = {};

export default defaultStaticContent;
